import {
  FormControl,
  Input,
  InputLabel,
  FormHelperText,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import Heading from "../heading"
import { Controller, useForm } from "react-hook-form"
import { getAccessToken, getSessionToken, pattern } from "./formUtils"
import "./forms.scss"
import { useIntl } from "gatsby-plugin-react-intl"
import axios from "axios"
import { getWebformURL } from "../../functions"
import { navigate } from "gatsby"
import ReCaptcha from "@pittica/gatsby-plugin-recaptcha"

const NewsletterForm = () => {
  const intl = useIntl()

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    formState,
  } = useForm()

  const [fullName, setFullName] = useState("")
  const [formResponse, setFormResponse] = useState("")
  const { isSubmitSuccessful, isSubmitting, isValid } = formState
  const [submitted, setSubmitted] = useState(false)
  const submit = token => {}

  const [formClass, setFormClass] = useState("")

  let classHide = !isSubmitting && isSubmitSuccessful ? "input-hide" : ""

  if (formClass != "") {
    classHide = formClass
  }

  const submitHandlerContact = async (values, e) => {
    const sessionToken = await getSessionToken()
      .then(data => {
        return data
      })
      .catch(err => console.log(err))

    if (values.first_name) {
      setFullName(values.first_name + " " + values.last_name)
    }

    const accessToken = await getAccessToken()
      .then(data => {
        return data
      })
      .catch(err => console.log(err))

    const options = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "X-CSRF-Token": sessionToken,
    }

    const body = {
      webform_id: "webform_newsletter",
      values: values,
    }

    axios({
      method: "post",
      url: getWebformURL(intl.locale),
      data: JSON.stringify(body),
      headers: options,
    })
      .then(data => {
        e.target.reset()
      })
      .catch(error => {
        setFormResponse("")
      })
  }

  return (
    <div className="blk-form newsletter">
      <form onSubmit={handleSubmit(submitHandlerContact)} noValidate={true}>
        <div className={classHide}>
          <Row>
            <Col className="newsletter-details">
              <FormControl required error={errors.first_name}>
                <InputLabel htmlFor="first_name">
                  {intl.formatMessage({ id: "form_inputs.first_name" })}
                </InputLabel>
                <Input
                  id="first_name"
                  {...register("first_name", {
                    required: true,
                    pattern: pattern.name,
                  })}
                />
                {errors.first_name && errors.first_name.type === "required" && (
                  <FormHelperText>
                    {intl.formatMessage({ id: "form_validation.required" })}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl required error={errors.last_name}>
                <InputLabel htmlFor="last_name">
                  {intl.formatMessage({ id: "form_inputs.last_name" })}
                </InputLabel>
                <Input
                  id="last_name"
                  {...register("last_name", {
                    required: true,
                  })}
                />
                {errors.last_name && errors.last_name.type === "required" && (
                  <FormHelperText>
                    {intl.formatMessage({ id: "form_validation.required" })}
                  </FormHelperText>
                )}
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col className="newsletter-details">
              <FormControl required error={errors.email}>
                <InputLabel htmlFor="email">
                  {intl.formatMessage({ id: "form_inputs.email" })}
                </InputLabel>
                <Input
                  id="email"
                  {...register("email", {
                    required: true,
                    pattern: pattern.email,
                  })}
                />
                {errors.email && errors.email.type === "pattern" && (
                  <FormHelperText>
                    {intl.formatMessage({
                      id: "form_validation.email_pattern",
                    })}
                  </FormHelperText>
                )}
                {errors.email && errors.email.type === "required" && (
                  <FormHelperText>
                    {intl.formatMessage({ id: "form_validation.required" })}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl required error={errors.country}>
                <InputLabel htmlFor="country">
                  {intl.formatMessage({ id: "form_inputs.country" })}
                </InputLabel>
                <Input
                  id="country"
                  {...register("country", {
                    required: true,
                    pattern: pattern.name,
                  })}
                />
                {errors.country && errors.country.type === "required" && (
                  <FormHelperText>
                    {intl.formatMessage({ id: "form_validation.required" })}
                  </FormHelperText>
                )}
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormControl>
                <Controller
                  name="consent"
                  control={control}
                  defaultValue={"No"}
                  render={({ field }) => (
                    <FormControlLabel
                      value={"Yes"}
                      control={<Checkbox {...field} />}
                      label={
                        <label>
                          {intl.formatMessage({ id: "privacy_policy.read" })}
                          <a
                            href={intl.formatMessage({
                              id: "privacy_policy.link",
                            })}
                          >
                            {" "}
                            {intl.formatMessage({ id: "privacy_policy.title" })}
                          </a>
                        </label>
                      }
                    />
                  )}
                />
              </FormControl>
            </Col>
          </Row>
          <Row className="contact-submit">
            <ReCaptcha
              action="newsletter"
              siteKey="6LduB9siAAAAAKfuxkKKPykVcN5B0ikuUKfIgUQo"
              onVerify={token => submit(token)}
              submitted={submitted}
            />
            <button
              className="btnLink"
              onClick={() => setSubmitted(true)}
              type="submit"
            >
              <span>{intl.formatMessage({ id: "form_inputs.send" })}</span>
            </button>
          </Row>
        </div>
        {formResponse && (
          <Row className="success-elem">
            <Col>
              <div className="form-message" style={{ color: "red" }}>
                {formResponse}
              </div>
            </Col>
          </Row>
        )}
        {!isSubmitting &&
          isSubmitSuccessful &&
          !formResponse &&
          (intl.locale === "fr"
            ? navigate(`/merci-abonnement-la-newsletter?titre=Newsletter&name=${fullName}`)
            : navigate(`/en/thank-you-subscription-newsletter?titre=Newsletter&name=${fullName}`))}
      </form>
    </div>
  )
}

export default NewsletterForm
